/* angular:styles/component:css;14a82479a834b783381cce3ca15d9691061352d5c47346bb77b750a51970778c;C:\Users\myElectrical240822\source\repos\myElectrical\mceMainApp\src\app\dashboard\help\help.component.ts */
.support-panel {
  display: inline-block;
  max-width: 100%;
}
.support-panel mat-expansion-panel {
  display: inline-block;
  max-width: 100%;
}
.support-panel-header-content {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 700;
}
/*# sourceMappingURL=help.component-O35OYYOX.css.map */
